/*
    THIS FILE WAS DEVELOPED BY MEHMET GUDUK
    © 2022 COPYRIGHT, LICENSED WITH GPL-3.0 LICENSE, AUTHOR IS MEHMET GUDUK
    https://github.com/mehmetguduk
*/

import React from 'react';

export default function About() {
    return (
        <div className="about">
            <h3 className="about-title">About</h3>
            <p className="about-content">
                As someone who grew up with computer technology, any work in relation to computers is a massive passion for me. I discovered my interest in design when I installed Adobe Photoshop CS6 on my computer a long time ago. Working on photos for hours with some chill background music was utterly joyful. Later, I continued this interest by making vector drawings with Adobe Photoshop Illustrator. Then realized that I can turn this into web development.
            </p>
        </div>
    )
}